var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoachesWhistle({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "142px",
    height: "129px",
    viewBox: "0 0 142 129",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "BTI_Coach") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Website",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Desktop_Research",
    transform: "translate(-150.000000, -1508.000000)",
    stroke: "#006AF9",
    strokeWidth: 4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Coach",
    transform: "translate(221.000000, 1572.814030) scale(-1, 1) translate(-221.000000, -1572.814030) translate(152.000000, 1509.814030)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M85.6769104,37.1879294 L85.6792257,37.1859697 L59.6454082,37.1859697 L57.0450075,43.8030962 L40.8660867,43.8030962 L37.6883014,37.1859697 L0,37.1859697 L0,68.8659249 L40.3998378,75.5356838 C40.1547027,77.3856573 40.0276491,79.2714655 40.0276491,81.1858297 C40.0276491,105.486608 60.3926798,125.18597 85.5139693,125.18597 C110.634969,125.18597 131,105.486608 131,81.1858297 C131,56.9382436 110.722952,37.2733171 85.6769104,37.1879294 Z",
    id: "Stroke-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67,81.1859697 C67,90.5746798 74.6113536,98.1859697 84.0001424,98.1859697 C93.3889312,98.1859697 101,90.5746798 101,81.1859697 C101,71.7972595 93.3889312,64.1859697 84.0001424,64.1859697 C74.6113536,64.1859697 67,71.7972595 67,81.1859697 Z",
    id: "Stroke-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.805305,66.1859697 C133.883323,66.1859697 138,61.9326004 138,56.6859697 C138,51.4393389 133.883323,47.1859697 128.805305,47.1859697 C125.512473,47.1859697 122.623925,48.9743081 121,51.6623697",
    id: "Stroke-5"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 35,
    y1: 20.1859697,
    x2: 28,
    y2: 7.18596968,
    id: "Stroke-7"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 67,
    y1: 22.1859697,
    x2: 74,
    y2: 9.18596968,
    id: "Stroke-9"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 51,
    y1: 20.1859697,
    x2: 51,
    y2: 0.185969675,
    id: "Stroke-11"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoachesWhistle);
export default __webpack_public_path__ + "static/media/Coaches_whistle.af1a093de0f4842e8f8cc82a445fabed.svg";
export { ForwardRef as ReactComponent };